// extracted by mini-css-extract-plugin
export default {"table_comp_header":"TableComponent_table_comp_header__2bWN7","tc_box":"TableComponent_tc_box__h-FxU"};